import React from 'react';
import SubIndustryCard from '../Common/SubIndustry';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { IndustryEnum } from '../../config/Profiler_enum';

const SubIndustry = (props) => {
  return (
    <SubIndustryCard
      industryType={IndustryEnum.FMCG}
      questionId={ProfilerQuestionID.FMCG_SUB_INDUSTRY}
      {...props}
    />
  );
};
export default SubIndustry;
